/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const loginAsRequestV4Schema = z.object({
  supportCaseNr: z
    .string()
    .nullish()
    .describe('The support case number the impersonation happens under. Required.'),
})
